import { GraphQlRequestService } from '../../../api/graphql-request-service';
import { Domains } from '../../constants';
import { Hasher } from '../hasher';
import { HasDependencies, hashString, Role } from '../types';
import { CacheBehaviour, ListAliasesQuery } from '../types-graphql';
import { handleGQLErrors } from '../utils';
import { Alias } from './types';
import { apiAliasToFrontendAlias } from './utils';

export interface AliasService extends HasDependencies {
  getAliases: (skipCache: boolean) => Promise<Alias[]>;
  setAlias: () => Promise<Alias[]>;
}

export class BackendAliasService implements AliasService, HasDependencies {
  constructor(
    readonly graphQlRequestService: GraphQlRequestService,
    readonly domain: Domains,
    readonly simulateRole: Role | null
  ) {}

  public getDeps = (): (string | undefined)[] => [
    hashString([
      ...this.graphQlRequestService.getDeps(),
      this.domain,
      Hasher.hash(this.simulateRole),
    ]),
  ];

  public getAliases = async (skipCache = false): Promise<Alias[]> => {
    const result: ListAliasesQuery = await handleGQLErrors(
      this.graphQlRequestService.graphQlSdk.listAliases({
        domain: this.domain,
        simulateRole: this.simulateRole?.id ?? null,
        cacheBehaviour: skipCache
          ? CacheBehaviour.SkipCacheBehaviour
          : CacheBehaviour.DontSkipCacheBehaviour,
      })
    );
    const modifiedResult =
      result.listAliases?.map((alias) => apiAliasToFrontendAlias(alias)) ?? [];
    return modifiedResult;
  };

  // TODO: add this function as well as a hook
  // that automatically updates the react-query cache
  // so that the ui refreshes automatically without page reload
  public setAlias = async (): Promise<Alias[]> => Promise.resolve([]);
}
